export default "__VITE_ASSET__DmRe7GuP__"